export const isAchieved = (threshold: number, value: number) => {
  return threshold <= value;
};
